import React, { useMemo } from 'react';
import { FUNDING_DEAL_BOARD_STAGES } from '../../utils/funding/constants';
import FundingDealStageColumn from './FundingDealStageColumn';

const FundingDealBoard = ({ deals, onSelectDeal, onStageChange, onCreateCommission, creatingCommissionId, saving }) => {
  const byStage = useMemo(() => {
    const grouped = Object.fromEntries(FUNDING_DEAL_BOARD_STAGES.map((stage) => [stage, []]));
    (deals || []).forEach((deal) => {
      if (grouped[deal.stage]) {
        grouped[deal.stage].push(deal);
      }
    });
    return grouped;
  }, [deals]);

  return (
    <div className="flex gap-4 overflow-x-auto pb-2">
      {FUNDING_DEAL_BOARD_STAGES.map((stage) => (
        <FundingDealStageColumn
          key={stage}
          stage={stage}
          deals={byStage[stage]}
          onSelectDeal={onSelectDeal}
          onStageChange={onStageChange}
          onCreateCommission={onCreateCommission}
          creatingCommissionId={creatingCommissionId}
          saving={saving}
        />
      ))}
    </div>
  );
};

export default FundingDealBoard;
